export default "__VITE_ASSET__CQXFY1qH__"